export default __webpack_public_path__ + "assets/images/eda62174f72afa6999129dec2bce1961.png";